// Theme management utilities
import { Theme } from '../types';

export const themes: Theme[] = [
  { id: 'default', name: 'Black & White', class: 'theme-default' },
  { id: 'orange-green', name: 'Orange & Green', class: 'theme-orange-green' },
  { id: 'cyan-pink', name: 'Cyan & Pink', class: 'theme-cyan-pink' },
  { id: 'purple-gold', name: 'Purple & Gold', class: 'theme-purple-gold' },
  { id: 'red-blue', name: 'Red & Blue', class: 'theme-red-blue' },
  { id: 'teal-coral', name: 'Teal & Coral', class: 'theme-teal-coral' }
];

export const applyTheme = (themeId: string): void => {
  const body = document.body;
  
  // Remove all theme classes
  themes.forEach(theme => {
    body.classList.remove(theme.class);
  });
  
  // Apply selected theme
  const selectedTheme = themes.find(theme => theme.id === themeId);
  if (selectedTheme) {
    if (themeId === 'cyan-pink') {
      // Cyan-pink is now the default, so no class needed
      // The CSS variables are already set in :root
    } else {
      body.classList.add(selectedTheme.class);
    }
  }
  
  // Save to localStorage
  localStorage.setItem('themev2', themeId);
};

export const getSavedTheme = (): string => {
  return localStorage.getItem('themev2') || 'cyan-pink';
};

export const initializeTheme = (): string => {
  const savedTheme = getSavedTheme();
  applyTheme(savedTheme);
  return savedTheme;
};
